import { Icon, IconProps } from "@chakra-ui/react"

const HomeSolidIcon = (props: IconProps) => (
  <Icon
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='23'
    viewBox='0 0 22 23'
    fill='none'
    {...props}
  >
    <path
      d='M4.02255 21.4063C2.60083 21.4063 1.44824 20.3153 1.44824 18.9682V9.16925C1.44824 8.42893 1.80428 7.72757 2.41376 7.26557L9.49462 1.90186C9.94704 1.55629 10.516 1.36719 11.1034 1.36719C11.6908 1.36719 12.2598 1.55629 12.7122 1.90186L19.7919 7.26557C20.4026 7.72757 20.7586 8.42893 20.7586 9.16925V18.9682C20.7586 20.3153 19.606 21.4063 18.1843 21.4063H4.02255Z'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.08618 21.4062V15.2833C8.08618 14.6927 8.34049 14.1264 8.79317 13.7089C9.24584 13.2913 9.8598 13.0567 10.5 13.0567H11.7069C12.347 13.0567 12.961 13.2913 13.4137 13.7089C13.8664 14.1264 14.1207 14.6927 14.1207 15.2833V21.4062'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Icon>
)

export default HomeSolidIcon
